// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GcLss","rightAdornment":"Header_rightAdornment__19FYl"};